<template>
    <el-container class="mainCont">
        <el-aside width="200px">
            <navs />
        </el-aside>
        <el-container>
            <el-header height="60px">
                <toper />
            </el-header>
            <el-main height="100%">
                <transition>
                    <router-view></router-view>
                </transition>
            </el-main>
        </el-container>
    </el-container>
</template>
<style>
html,
body,
#app,
.mainCont {
    height: 100%;
}

.mainCont {
    width: 100%;
}

.el-header {
    background-color: #fff;
    display: flex;
    align-items: center;
}

.el-main {
    padding: 7px !important;
}


body {
    margin: 0;
    background-color: #f2f3f7;
}
</style>

<script>
import navs from "@/components/branchNavs";
import toper from "@/components/branchToper";

export default {
    components: { navs, toper },
};
</script>
